import { type ReactNode } from 'react';
import { useAuthStore } from '@/stores/authStore';
import { ShieldAlert } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useNavigate } from 'react-router-dom';

interface RoleGuardProps {
  role: 'ADMIN' | 'MANAGER' | 'USER';
  children: ReactNode;
}

const roleHierarchy: Record<string, number> = {
  USER: 1,
  MANAGER: 2,
  ADMIN: 3,
};

export function RoleGuard({ role, children }: RoleGuardProps) {
  const user = useAuthStore((s) => s.user);
  const navigate = useNavigate();

  if (!user || roleHierarchy[user.role] < roleHierarchy[role]) {
    return (
      <div className="flex flex-col items-center justify-center py-24 text-center">
        <div className="mx-auto flex h-16 w-16 items-center justify-center rounded-full bg-destructive/10">
          <ShieldAlert className="h-8 w-8 text-destructive" />
        </div>
        <h2 className="mt-6 text-2xl font-bold">Access Denied</h2>
        <p className="mt-2 max-w-md text-muted-foreground">
          You do not have the required permissions to access this page.
          Contact your administrator if you believe this is an error.
        </p>
        <Button className="mt-6" onClick={() => navigate('/dashboard')}>
          Go to Dashboard
        </Button>
      </div>
    );
  }

  return <>{children}</>;
}
